// 📁 hooks/useGoogleStreetView.js
// utilisé dans : components/StreetView/StreetViewModal.jsx 
// Hook custom pour gérer la logique Google Maps Street View
import { /*useEffect,*/ useRef, useState, useCallback } from 'react';

export const useGoogleStreetView = (coords, heading, pitch, zoom, isMobile) => {
  const panoramaRef = useRef(null);
  const panoramaInstanceRef = useRef(null);
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAvailable, setIsAvailable] = useState(true);
  const [address, setAddress] = useState('');

  const cleanupPanorama = useCallback(() => {
    panoramaInstanceRef.current = null;
  }, []);

  const initializePanorama = useCallback(() => {
    if (!window.google?.maps) {
      setError("Google Maps n'est pas chargé");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const position = { lat: parseFloat(coords.lat), lng: parseFloat(coords.lng) };
    const streetViewService = new window.google.maps.StreetViewService();
    const geocoder = new window.google.maps.Geocoder();

    // Géocodage
    geocoder.geocode({ location: position }, (results, status) => {
      if (status === 'OK' && results[0]) {
        setAddress(results[0].formatted_address);
      }
    });

    // Vérification disponibilité
    streetViewService.getPanorama(
      { 
        location: position, 
        radius: 50,
        source: window.google.maps.StreetViewSource.OUTDOOR
      },
      (data, status) => {
        if (status === 'OK') {
          setIsAvailable(true);
          
          const panorama = new window.google.maps.StreetViewPanorama(
            panoramaRef.current,
            {
              position: data.location.latLng,
              pov: { heading, pitch },
              zoom,
              addressControl: true,
              addressControlOptions: {
                position: window.google.maps.ControlPosition.TOP_LEFT
              },
              linksControl: true,
              panControl: true,
              enableCloseButton: false,
              fullscreenControl: true,
              fullscreenControlOptions: {
                position: window.google.maps.ControlPosition.RIGHT_TOP,
              },
              motionTracking: !isMobile,
              motionTrackingControl: !isMobile,
              showRoadLabels: true,
              visible: true,
            }
          );

          panoramaInstanceRef.current = panorama;
          setLoading(false);
        } else {
          setIsAvailable(false);
          setError(`Street View indisponible : ${status}`);
          setLoading(false);
        }
      }
    );
  }, [coords, heading, pitch, zoom, isMobile]);

  return {
    panoramaRef,
    loading,
    error,
    isAvailable,
    address,
    initializePanorama,
    cleanupPanorama
  };
};